//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ContainerRowReduxTextField from '../../components/common/ContainerRowReduxTextField'
import ContainerRowReduxCheckboxField from '../ProjectDemeter/common/ContainerRowReduxCheckboxField'
import ContainerRowReduxSelectAndOverrideField from '../ProjectDemeter/common/ContainerRowReduxSelectAndOverrideField'
import ContainerRowReduxReadonlyTextAndOverrideField from '../ProjectDemeter/common/ContainerRowReduxReadonlyTextAndOverrideField'
import ContainerRowError from '../../components/common/ContainerRowError'
import ContainerRowReduxAutoCompleteAndOverrideField from '../../components/common/ContainerRowReduxAutoCompleteAndOverrideField'
import * as actions from '../../redux/hermes/actions';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import type { ReducerState$Type } from '../../redux/hermes/flowTypes';
import type { InvoiceHeaderForm$Props } from './flowTypes'

const refreshTotalAmount=(props:InvoiceHeaderForm$Props)=>{
    const { hermes,isOverrideInvTotal,subTotal,tax,additional } = props;
    
    if (!isOverrideInvTotal){
        let invTotal=0
        if (!isNaN(subTotal)){
            invTotal+=parseFloat(subTotal)
        }
        if (!isNaN(tax)){
            invTotal+=parseFloat(tax)
        }
        if (!isNaN(additional)){
            invTotal+=parseFloat(additional)
        }
        const changeFieldValue = (props.changeFieldValue:any)
        changeFieldValue('invTotal',invTotal.toFixed(2))
    }
}

const subTotalOnChange=(e:any,props:InvoiceHeaderForm$Props)=>{
    const { hermes,isOverrideInvTotal,tax,additional } = props;
    if (!isOverrideInvTotal && !isNaN(e.target.value) ) {
        let invTotal =  parseFloat(e.target.value) 
        if (!isNaN(tax)) {
            invTotal += parseFloat(tax)
        }
        if (!isNaN(additional)){
            invTotal += parseFloat(additional)
        }
        const changeFieldValue = (props.changeFieldValue:any)
        changeFieldValue('invTotal',invTotal.toFixed(2))
    }
}

const taxOnChange=(e:any,props:InvoiceHeaderForm$Props)=>{
    const { hermes,isOverrideInvTotal,subTotal,additional } = props;

    if (!isOverrideInvTotal && !isNaN(e.target.value) ) {
        let invTotal =  parseFloat(e.target.value) 
        if (!isNaN(subTotal)) {
            invTotal += parseFloat(subTotal)
        }
        if (!isNaN(additional)){
            invTotal += parseFloat(additional)
        }
        const changeFieldValue = (props.changeFieldValue:any)
        changeFieldValue('invTotal',invTotal.toFixed(2))
    }
}

const additionalOnChange=(e:any,props:InvoiceHeaderForm$Props)=> {
    const { hermes,isOverrideInvTotal,subTotal,tax } = props;

    if (!isOverrideInvTotal && !isNaN(e.target.value)  ) {
        let invTotal =  parseFloat(e.target.value) 
        if (!isNaN(subTotal)) {
            invTotal += parseFloat(subTotal)
        }
        if (!isNaN(tax)){
            invTotal += parseFloat(tax)
        }
        const changeFieldValue = (props.changeFieldValue:any)
        changeFieldValue('invTotal',invTotal.toFixed(2))
    }
}

const renderSubmitButton=(props:InvoiceHeaderForm$Props)=>{
    const { pristine,submitting,isInvalidDoc,invalid } = (props:any);
    const submitOpenActionDialog = (props.submitOpenActionDialog:any)
    const hermes:ReducerState$Type = (props.hermes:any)
    
    if (isInvalidDoc && Object.keys(hermes.formError).length == 0){
        return <button type="button" onClick={()=> submitOpenActionDialog()} className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit As Invalid Invoice</button>; 
    }else {
        return (
            <div>
                <button type="button" onClick={()=> submitOpenActionDialog()} 
                className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
            </div>    
        )
    }
}

class InvoiceHeaderForm extends React.Component<InvoiceHeaderForm$Props> {
    
    refreshEditData(){
        if (this.props.isVerifyMode){
            const getTaskData = (this.props.getTaskData:any)
            getTaskData(this.props.jwt,this.props.taskAcceptedInfoId)
        }
    }

    componentWillMount(){
        const { jwt, hermes } = this.props
        if (!hermes.hermesVendorsLoaded){
            const populateVendorsList=(this.props.populateVendorsList:any)
            populateVendorsList(jwt);
        }
    }
    
    componentDidUpdate(){
        refreshTotalAmount(this.props)
    }

    componentDidMount(){
        this.refreshEditData()
    }

    render(){
        const { pristine,submitting,hermes,
            isInvalidDoc,isOverrideInvTotal,actConfDialog,
            jwt,taskAcceptedInfoId,isOverrideVendorName,isOverrideAdditionalNotfound,isOverrideTaxNotfound
         } = (this.props:any);

        const changeFieldValue = (this.props.changeFieldValue:any)
       
        if (hermes.invoiceSubmitted) {
            return <Redirect to='/projectHermes/submittedForm' />;
        }

        const autoCompleteDataSourceConfig = {
            text: "vendor_name",
            value: "vendor_name"
        }

        return (
            <div className='container'>
                <ContainerRowReduxCheckboxField field={'isInvalidDoc'} label={'Invalid Document / Missing Pages / Not load'} />
                
                <ContainerRowReduxAutoCompleteAndOverrideField 
                    autoCompleteField={'vendorName'} 
                    autoCompleteDatasourceConfig={autoCompleteDataSourceConfig}
                    label={'Vendor Name'}
                    datas={hermes.hermesVendors}
                    checkboxField={'isOverrideVendorName'}
                    checkboxLabel={'Override this Vendor Name field'}
                    isOverride={isOverrideVendorName}
                    changeFieldValue={changeFieldValue}
                    parentProps={this.props}
                />
                <ContainerRowReduxTextField field={'invNo'} label={'Invoice Number'} />
                <ContainerRowReduxTextField field={'invDate'} label={'Invoice Date'} />
                <ContainerRowReduxTextField field={'poNo'} label={'PO Number'} />
                <ContainerRowReduxTextField field={'subTotal'} label={'Sub Total'} textType={'number'} textOnChangeFunc={subTotalOnChange} parentProps={this.props}  />
                
                <ContainerRowReduxTextField 
                    field={'tax'} label={'Tax'} 
                    textType={'number'} textOnChangeFunc={taxOnChange} 
                    parentProps={this.props} 
                    checkboxField={'isOverrideTaxNotfound'}
                    checkboxBool={isOverrideTaxNotfound}
                    checkboxLabel={'Tax not found in document'}
                />
                <ContainerRowReduxTextField 
                    field={'additional'} label={'Additional'} 
                    textType={'number'} textOnChangeFunc={additionalOnChange} 
                    parentProps={this.props}  
                    checkboxField={'isOverrideAdditionalNotfound'}
                    checkboxBool={isOverrideAdditionalNotfound}
                    checkboxLabel={'Additional not found in document'}
                />

                <ContainerRowReduxReadonlyTextAndOverrideField 
                    textField={'invTotal'} textLabel={'Invoice Total'} textType={'number'}
                    checkboxField={'isOverrideInvTotal'} checkboxLabel={'Override this Invoice Total field'}
                    isOverride={isOverrideInvTotal} notOverrideFunc={refreshTotalAmount} 
                    parentProps={this.props}
                />
                
                <ContainerRowError errorMsg={hermes.error} />
            
                <div className="row">
                    <div className="col-sm">
                      {renderSubmitButton(this.props)}
                    </div>
                </div>   
            </div>    
        )
    }
}

const mapStateToProps:any = (state, ownProps) => {
    const selector = ownProps.selector

    return {
        isInvalidDoc: selector(state, 'isInvalidDoc'),
        isOverrideInvTotal: selector(state, 'isOverrideInvTotal'),
        invTotal: selector(state, 'invTotal'),
        tax: selector(state, 'tax'),
        additional: selector(state, 'additional'),
        subTotal: selector(state, 'subTotal'),
        isOverrideVendorName: selector(state, 'isOverrideVendorName'),
        isOverrideAdditionalNotfound: selector(state, 'isOverrideAdditionalNotfound'),
        isOverrideTaxNotfound: selector(state, 'isOverrideTaxNotfound'),
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      getTaskData: (jwt:string,taskAcceptedInfoId:number)=>{
        dispatch(actions.getTaskData(ownProps.hermes, jwt, taskAcceptedInfoId))  
      },
      populateVendorsList: (jwt:string)=>{
        dispatch(actions.populateVendorsList(jwt))  
      },
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceHeaderForm)


// WEBPACK FOOTER //
// ./src/views/ProjectHermes/InvoiceHeaderForm.js